import { render } from "./App.vue?vue&type=template&id=30c39916"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=30c39916&lang=css"

import exportComponent from "E:\\workspace\\cursos\\udemy\\curso-vue-cero-experto\\04-pokemon-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__